// @flow
import styled from 'styled-components';
import SVGIcon from '~/core/icons/svg-icons';
import { VelocityTransitionGroup } from 'velocity-react';

const minifiedHeight = 4;
const detailItemHeight = 4.5;
const scheduleHeight = 38;
const heightRemove = 2.2;
const borderRadius = 1;
const easeOutQuint = 'cubic-bezier(0.23, 1, 0.32, 1)';

export const Main = styled.div`
    border: solid 1px ${p => p.theme.secondaryMedium};
    border-radius: ${borderRadius}em;
    display: flex;
    flex-direction: column;
    height: ${p =>
        p.isDetailVisible
            ? minifiedHeight +
              (p.isSchedule ? scheduleHeight : p.detailsLength * detailItemHeight) +
              (p.removable ? heightRemove : borderRadius)
            : minifiedHeight}em;
    margin-bottom: 1em;
    max-width: 30em;
    overflow: hidden;
    position: relative;
    transition: height 0.3s ${easeOutQuint};
`;

export const Header = styled.div`
    align-items: center;
    border-bottom: solid 1px ${p => p.theme.secondaryLight};
    cursor: ${p => (p.clickable ? 'pointer' : 'inherit')};
    display: flex;
    height: ${minifiedHeight}em;
    padding: 0 ${borderRadius}em;
    position: absolute;
    width: 100%;
`;

export const AttributeIconContainer = styled.div`flex: 0 0 3em;`;

export const AttributeIcon = styled(SVGIcon)`
    height: 2.2em;
    width: 2.2em;

    & > g {
        fill: ${p => (p.quickAction ? p.theme.black : p.theme.mainBrandColor)};
    }
`;

export const ActionContainer = styled(VelocityTransitionGroup).attrs({ component: 'div' })`
    align-items: center;
    display: flex;
    flex: 0 0 3em;
    height: 3em;
    justify-content: flex-end;
    overflow: hidden;
    position: relative;
    will-change: transform, opacity;
`;

export const MoreIcon = styled(SVGIcon)`
    height: 3em;
    position: absolute;
    right: 0;
    width: 2.2em;

    & > g {
        fill: ${p => p.theme.secondaryHeavy};
    }
`;

export const TickIcon = styled(SVGIcon)`
    height: 3em;
    position: absolute;
    right: 0;
    width: 2.2em;

    & > g {
        fill: ${p => p.theme.mainBrandColor};
    }
`;

export const Done = styled.div`
    color: ${p => p.theme.mainBrandColor};
    cursor: pointer;
    line-height: 3em;
    position: absolute;
    right: 0;
`;

export const TextSection = styled.div`flex: 1 0 auto;`;

export const Title = styled.div`font-size: 1.2em;`;

export const Description = styled.div`color: ${p => p.theme.secondaryBase};`;

export const Detail = styled.div`
    position: absolute;
    top: ${minifiedHeight}em;
    width: 100%;
`;

export const DetailItem = styled.div`
    align-items: center;
    display: flex;
    height: ${p => (p.isSchedule ? scheduleHeight : detailItemHeight)}em;
    padding: 0 ${borderRadius}em;
    width: 100%;
`;

export const RemoveAttribute = styled.div`
    align-items: center;
    background-color: ${p => p.theme.secondaryLight};
    border-top: solid 1px ${p => p.theme.secondaryMedium};
    color: ${p => p.theme.mainBrandColor};
    cursor: pointer;
    display: flex;
    height: ${heightRemove}em;
    justify-content: center;
    width: 100%;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/action-attribute/styles.js